import "../../styles/UserDashboard/choosePaymentMethodModal.scss";

export default function ChoosePaymentMethodModal({open, setOpen, setPaymentOption}) {
  return (
    open &&
    <div className="choose-payment-method-modal">
    <div className="choose-payment-method-modal__inner">
    <div className="choose-payment-method-modal__inner__title">
        Choose a payment method
      </div>
      <div className="choose-payment-method-modal__inner__group"
      onClick={() => {
        setPaymentOption("paystack")
        setOpen(false)
      }}
      >
        <div>Pay with</div>
        <div>Paystack</div>
      </div>
      <div className="choose-payment-method-modal__inner__group"
     onClick={() => {
        setPaymentOption("bank transfer")
        setOpen(false)
      }}
      >
        <div>Pay to</div>
        <div>Seller’s account</div>
      </div>
    </div>
    </div>
  );
}
